import React from "react";

import Header from "./Header/Header";
import SEOHead from "./SEO/SEOHead";

import "../css/MainPage.css";
import Footer from "./Footer/footer";
import Banner from "./Hero/banner";
import Store from "./Hero/Store";
import Principles from "./Hero/Principles";
import Chapters from "./Hero/Chapters";
import Testops from "./Hero/Testops";
import QATestingSection from "./Hero/QATestingSection";
import { CtaBanner } from "./common/ui";

const MainPage = () => {
  // Structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "name": "Froth TestOps",
        "url": "https://frothtestops.com",
        "logo": "https://frothtestops.com/og-image.png",
        "description": "AI-powered test management, automation and security testing platform",
        "foundingDate": "2023",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer service",
          "email": "support@frothtestops.com"
        },
        "sameAs": [
          "https://twitter.com/frothtestops",
          "https://linkedin.com/company/frothtestops"
        ]
      },
      {
        "@type": "SoftwareApplication",
        "name": "Froth TestOps",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web, Android, iOS",
        "url": "https://frothtestops.com",
        "description": "Test management, automation, API, performance and security testing with FrothAI.",
        "publisher": { "@type": "Organization", "name": "Robotico Digital" }
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Froth TestOps | AI-Powered Test Management, Automation & Security Testing"
        description="One platform for requirements, test management, automation, API, performance and security testing, with FrothAI to generate tests, scripts and release-readiness reports."
        keywords="test management, QA tools, software testing, test automation, AI testing, performance testing, security testing, Froth TestOps"
        ogImage="/og-image.png"
        structuredData={structuredData}
      />

      <div className="fd-main-wrapper page-padding">
        <Header />
        <main>
          <Banner />
          <Testops />
          <section className="ft-section home-overview" aria-label="Overview">
            <div className="ft-container">
              <h2 className="ft-statement">
                One platform for the whole QA lifecycle.{" "}
                <span>
                  Froth TestOps brings requirements, test design, manual and automated execution, defects, and
                  performance, security and code testing together, with FrothAI helping at every step.
                </span>
              </h2>
              <Principles />
            </div>
          </section>
          <Chapters />
          <QATestingSection />
          <Store />
          <CtaBanner />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default MainPage;
